import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { SearchBaseClass } from "../../helpers/search";

var Pexels = /*#__PURE__*/function (_SearchBaseClass) {
  _inherits(Pexels, _SearchBaseClass);

  var _super = _createSuper(Pexels);

  function Pexels(apiKey) {
    _classCallCheck(this, Pexels);

    return _super.call(this, {
      apiKey: apiKey,
      name: "pexels",
      icon: "<svg aria-hidden=\"true\" viewbox=\"0 0 256 256\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M21 0h-4v255l72 1h71v-35l1-35 4-1a97 97 0 0053-33 81 81 0 0013-22l7-22v-3-23-2l-1-3v-2a95 95 0 00-42-60l-3-3-13-6a98 98 0 00-30-6H21zm130 37a85 85 0 008 1l11 5a57 57 0 0131 62c-5 23-23 41-45 45l-20 1h-12v68H53v-91l1-91h97z\" fill=\"#000\" fill-rule=\"nonzero\"/></svg>",
      color: "#05a081",
      poweredByUrl: "https://pexels.com",
      popularEndpoint: function popularEndpoint(apiKey) {
        return "https://api.pexels.com/v1/curated?per_page=9&page=1";
      },
      searchEndpoint: function searchEndpoint(apiKey, query) {
        return "https://api.pexels.com/v1/search?query=".concat(encodeURIComponent(query), "&per_page=12&page=1");
      },
      getButton: function getButton(image) {
        return "<div class=\"result\">\n        <button aria-label=\"".concat(image.photographer || "", "\" data-full-url=\"").concat(image.src.large2x, "\" style=\"background-image: url('").concat(image.src.tiny, "')\"></button><small class=\"author\">\n        <span>").concat(image.photographer, "</span>\n      </small></div>");
      },
      getSearchResults: function getSearchResults(response) {
        return response.photos;
      },
      getPopularResults: function getPopularResults(response) {
        return response.photos;
      },
      fetchSettings: function fetchSettings(apiKey) {
        return {
          headers: {
            Authorization: apiKey
          }
        };
      }
    });
  }

  return Pexels;
}(SearchBaseClass);

export { Pexels as default };